module.exports = __webpack_public_path__ + "img/jacob.bbe7e269.png";